import api from '../services/api';
import { isAccessTokenValid } from './AuthController';

export const getAllSetting = async () => {
    try {
        await isAccessTokenValid();
        const response = await api.get('/setting');
        return response.data.data;
    } catch (error) {
        throw error.response?.data || error.message;
    };
};

export const updateSetting = async (data) => {
    try {
        await isAccessTokenValid();
        const response = await api.put(`/setting`, data);
        return response.data.data;
    } catch (error) {
        throw error.response?.data || error.message;
    };
};
